<template>
  <div class="auditlog">
    <el-scrollbar class="auditlog_el">
      <div class="each_auditlog_log"
           v-for="item in auditLogs">
        <div class="each_auditlog_time">{{item.time_create | formatTime}}</div>
        <div class="audit_log_person">
          <img src="../../../static/img/avatar.png"
               alt=""
               v-if='!item.head_img'>
          <img :src="item.head_img"
               alt=""
               v-if='item.head_img'>
          <span class="name">{{item.user_name}}</span>
        </div>
        <div class="audit_log_send">
          <span class="send_title">{{item.content}}</span>
          <span class="send_name"
                v-if='item.to_user_name'>{{item.to_user_name}}</span>
        </div>
        <div class="audit_log_send"
             v-if='item.flag_audit !== null'>
          <span class="send_title">审核结果：</span>
          <span class="send_name yes"
                style="color:#67C23A;"
                v-if='item.flag_audit === true'>审核通过</span>
          <span class="send_name no"
                style="color:#F86C7D;"
                v-if='item.flag_audit === false'>审核不通过</span>
        </div>
        <div class="audit_log_send"
             v-if='item.audit_comment'>
          <span class="send_title">审核意见：</span>
          <span class="send_title">{{item.audit_comment}}</span>
        </div>

      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import { getUrlCode } from '../../../utils/index.js'
import * as api from '../../../api'
export default {
  name: 'auditlogs',
  data() {
    return {

    }
  },
  created() {

  },
  components: {

  },
  computed: {
    auditLogs() {
      return this.$store.state.logs.auditLogs
    }
  },
  mounted() {


  },
  destroyed() {

  },
  methods: {


  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='stylus' scoped>
@import '../../../styles/audit_comment.styl'
</style>
